/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';

import styled from '@emotion/styled';

const StyledDiv = styled('div')`
  width: 100%;
  padding-bottom: 40px;

  @media only screen and (min-width: 768px) {
    width: 50%;
    height: 100%;
  }

  &:nth-of-type(odd) {
    div::before {
      background: ${({ theme }) => theme.primary.base};
    }

    h3 {
      color: ${({ theme }) => theme.secondary.base};
    }
  }

  &:nth-of-type(even) {
    div::before {
      background: ${({ theme }) => theme.secondary.base};
    }

    h3 {
      color: ${({ theme }) => theme.secondary.base};
    }
  }
`;

const StyledContentDiv = styled('div')`
  padding: 0 40px;
  margin-top: -4px;
  font-family: ${({ theme }) => theme.fonts.light};
  color: ${({ theme }) => theme.text.medium};

  &::before {
    content: '';
    visibility: visible;
    width: 96px;
    height: 16px;
    display: block;
  }
`;

const StyledH3 = styled('h3')`
  font-size: 20px;
  font-weight: bold;
`;

const ProductFeatureGridItem = ({ children, image, title }) => (
  <StyledDiv>
    <Img {...image} />
    <StyledContentDiv>
      <StyledH3>{title}</StyledH3>
      <p>{children}</p>
    </StyledContentDiv>
  </StyledDiv>
);

ProductFeatureGridItem.propTypes = {
  children: PropTypes.any,
  images: PropTypes.shape({
    alt: PropTypes.string,
  }).isRequired,
  title: PropTypes.string.isRequired,
};

export default ProductFeatureGridItem;
